import { General } from "../../../siteManagement/general.js";
import { FAIcon } from "../../core/components/faIcon.js";
import { Config } from "../../core/config/config.js";
import { Helper } from "../../core/util/helper.js";
import React from "react"
export class AssignmentView extends React.Component<{ assignment: Assignment }, any>{

    private parseDate = (value: Date | string) => {
        const date = Helper.dates.toDate(value);
        return kendo.toString(date, 'g');
    }

    private onClick = () => {
        General.Sheet.Manager.createSheetWithUrl(`ResourcePlanning/EditByGuid?isguid=${this.props.assignment.IsGuid}`);
    }

    private renderInfoView = () => {
        const assignment = this.props.assignment;
        return (
            <div className="assignment-view" style={{ height: "100%", display: "grid", gridTemplateRows: "45px repeat(5, 25px) 1fr", gridTemplateColumns: "25px 10px auto", cursor: "pointer" }} onClick={this.onClick}>
                <FAIcon name="calendar-circle-user" prefix={"fal"} style={{ gridRow: "1/8", gridColumn: "1/4", alignItems: "center", justifyContent: "center", display: "flex", fontSize: "16em", opacity: "0.1" }} />
                <div style={{ zIndex: 100, gridRow: "1/2", gridColumn: "1/4", alignItems: "center", justifyContent: "center", display: "flex", fontSize: "medium", padding: "5px", lineHeight: "20px", fontWeight: "bold" }}>
                    <a target="_blank" onClick={(e) => e.stopPropagation()} href={`${Config.baseUrl}Procedure/EditByGuid?isguid=${this.props.assignment.IsGuid}`}>
                        {assignment.Title}
                    </a>
                </div>
                <FAIcon name="user" prefix={"fal"} style={{ gridRow: "2/3", gridColumn: "1/2", alignItems: "center", justifyContent: "center", display: "flex" }} />
                <div style={{ gridRow: "2/3", gridColumn: "3/4", alignItems: "center", display: "flex" }}>
                    {Helper.isNullOrEmpty(assignment.Responsible) ? "n/a" : assignment.Responsible}
                </div>
                <FAIcon name="calendar-alt" prefix={"fal"} style={{ gridRow: "3/4", gridColumn: "1/2", alignItems: "center", justifyContent: "center", display: "flex" }} />
                <div style={{ gridRow: "3/4", gridColumn: "3/4", alignItems: "center", display: "flex" }}>
                    {this.parseDate(assignment.Start)} - {this.parseDate(assignment.End)}
                </div>
                <FAIcon name="question" prefix={"fal"} style={{ gridRow: "4/5", gridColumn: "1/2", alignItems: "center", justifyContent: "center", display: "flex" }} />
                <div style={{ gridRow: "4/5", gridColumn: "3/4", alignItems: "center", display: "flex" }}>
                    {assignment.Code}
                </div>
                <FAIcon name="folder-open" prefix={"fal"} style={{ gridRow: "5/6", gridColumn: "1/2", alignItems: "center", justifyContent: "center", display: "flex" }} />
                <div style={{ gridRow: "5/6", gridColumn: "3/4", alignItems: "center", display: "flex" }}>
                    {assignment.Project}
                </div>
                <FAIcon name="info" prefix={"fal"} style={{ gridRow: "6/7", gridColumn: "1/2", alignItems: "center", justifyContent: "center", display: Helper.isNullOrEmpty(assignment.Description) ? "none" : "flex" }} />
                <div style={{ gridRow: "6/8", gridColumn: "3/4", padding: "3px 3px 3px 0", lineHeight: "1.3em" }}>
                    {assignment.Description}
                </div>
            </div>
        );
    }

    private renderDeleted = () => {
        return (
            <div style={{ display: "grid", height: "100%" }}>
                <div style={{ display: "flex", justifyContent: "center", gridArea: "1/1/1/1", alignItems: "center", height: "100%" }}>
                    <i className={`fal fa-times fa-10x`} style={{ opacity: 0.1, fontSize: "225px" }}></i>
                </div>
                <div style={{ textAlign: "center", gridArea: "1/1/1/1", paddingTop: "25%", height: "100%" }}>
                    <label style={{ fontSize: "15px" }}>
                        {Helper.getTranslation("SmartSearch.AssignmentIsDeleted")}
                    </label>
                </div>
            </div>
        );
    }

    render() {
        const assignment = this.props.assignment;
        return Helper.hasValue(assignment) ? this.renderInfoView() : this.renderDeleted();
    }
}


interface Assignment {
    Code: string;
    End: Date | string;
    IsContainer: boolean;
    IsGuid: string;
    PIndex: number;
    ProjNr: string;
    Project: string;
    Responsible: string;
    Start: Date | string;
    Title: string;
    Description: string;
}

